import { useContext } from "react";

import ProposalInputContext from "../../../context/ProposalInputContext";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import WorkOutlinedIcon from '@mui/icons-material/WorkOutlined';

import ExpandableSectionHeader from "./ExpandableSectionHeader";

const BDMInfoForm = () => {
  const {
    values, setValues, formErrors, collapseValues, setCollapseValue, sectionStyle
  } = useContext(ProposalInputContext);

  return (
    <Grid container spacing={2} sx={sectionStyle}>
      <ExpandableSectionHeader
        sectionTitle='4. BDM Information'
        showSection='showBDMInfo'
        icon={<WorkOutlinedIcon sx={{ color: "text.secondary" }} />}
        collapseValues={collapseValues}
        setCollapseValue={setCollapseValue}
      />

      {collapseValues?.showBDMInfo &&
        <>
          <Grid size={{ xs: 6 }}>
            <TextField
              variant="outlined"
              label="BDM full name *"
              name='bdmFullName'
              value={values?.bdmFullName}
              onChange={e =>
                setValues(prev => ({
                  ...prev,
                  bdmFullName: e.target.value
                }))
              }
              helperText={formErrors['bdmFullName']}
              error={'bdmFullName' in formErrors}
              fullWidth
            />
          </Grid>

          <Grid size={{ xs: 6 }}>
            <TextField
              variant="outlined"
              label="BDM email address *"
              name='bdmEmail'
              value={values?.bdmEmail}
              onChange={e =>
                setValues(prev => ({
                  ...prev,
                  bdmEmail: e.target.value
                }))
              }
              helperText={formErrors['bdmEmail']}
              error={'bdmEmail' in formErrors}
              fullWidth
            />
          </Grid>

          <Grid size={{ xs: 6 }}>
            <TextField
              variant="outlined"
              label="BDM main phone number *"
              name='bdmPhone'
              value={values?.bdmPhone}
              onChange={e =>
                setValues(prev => ({
                  ...prev,
                  bdmPhone: e.target.value
                }))
              }
              helperText={formErrors['bdmPhone']}
              error={'bdmPhone' in formErrors}
              fullWidth
            />
          </Grid>

          <Grid size={{ xs: 6 }}>
            <TextField
              variant="outlined"
              label="Job title of quote writer *"
              name='quoteWriterJobTitle'
              value={values?.quoteWriterJobTitle}
              onChange={e =>
                setValues(prev => ({
                  ...prev,
                  quoteWriterJobTitle: e.target.value
                }))
              }
              helperText={formErrors['quoteWriterJobTitle']}
              error={'quoteWriterJobTitle' in formErrors}
              fullWidth
            />
          </Grid>
        </>
      }
    </Grid>
  );
};

export default BDMInfoForm;